import { Box, BoxProps } from '@chakra-ui/react';
import { Field, FieldProps } from 'formik';

import { FormGroup, FormGroupProps } from './FormGroup';

export type FieldWrapperProps = {
  name: string;
  as: (props: FieldProps) => React.ReactNode;
  boxProps?: BoxProps;
  required?: boolean;
  label?: string;
  helper?: string;
  formGroupProps?: FormGroupProps;
};

export const FieldWrapper = ({
  name,
  as,
  required = false,
  label,
  helper,
  boxProps,
  formGroupProps,
}: FieldWrapperProps) => {
  const formProps = {
    required,
    label,
    helper,
    ...formGroupProps,
  };

  return (
    <Box {...boxProps} mb="4">
      <Field name={name}>
        {({
          field, // { name, value, onChange, onBlur }
          form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <FormGroup {...formProps} error={meta.error}>
            {as({ field, form, meta })}
          </FormGroup>
        )}
      </Field>
    </Box>
  );
};
